import { render, staticRenderFns } from "./EditSubscriptionCategoriesLoader.vue?vue&type=template&id=2ffc0b92"
import script from "./EditSubscriptionCategoriesLoader.vue?vue&type=script&lang=ts"
export * from "./EditSubscriptionCategoriesLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports